import { applyCouponCode } from '@/utils/apiEndpoints'
import { Button, Input, Space } from 'antd'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import common from '@/utils/common'

export const DiscountCodeInput = ({
  value,
  onChange = () => { },
  tripId,
  applyText = 'Apply',
  showLogin = () => { },
  setPreferences = () => { },
  preferences
}) => {
  const [code, setCode] = useState(value?.couponCode || '')
  const [loading, setLoading] = useState(false)
  const { currentUser } = useSelector((state) => state.auth)
  const apply = async () => {
    try {
      if (!currentUser?._id) {
        showLogin(true)
        return
      }
      setLoading(true)
      const res = await applyCouponCode({
        tripId: tripId,
        couponCode: code.toUpperCase(),
      })
      onChange(res.result)
      if (Array.isArray(preferences.discounts) && preferences.discounts.some(discount => discount._id === res.result._id)) {
        common.errorToast('This discount has already been applied');
      } else {
        common.successToast('Discount applied');
        setPreferences({
          ...preferences,
          coupon: { ...res.result },
        });
      }

    } catch (er) {
      common.errorToast('This discount does not exist');
    } finally {
      setLoading(false)
    }
  }

  return (
    <Space>
      <Input placeholder='Discount Code' value={code} onChange={(e) => setCode(e.target.value)} />
      {value?._id ? (
        <Button
          onClick={() => {
            setCode('')
            onChange('')
          }}
          type="link"
        >
          Remove
        </Button>
      ) : (
        <Button type="ghost" onClick={apply} loading={loading}>
          {applyText}
        </Button>
      )}
    </Space>
  )
}
